const urlRegex =
  /^(?:(?:http|https):\/\/)?(?:www\.)?(?:instagram\.com|instagr\.am)\/p\/([A-Za-z0-9-_]+)/;

export function isInstagramPost(url: string) {
  return urlRegex.test(url);
}
